import type { IconData } from '@stacksjs/iconify-core'

export const devicesCpu: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0v2h2V0h2v2h3v3h2v2h-2v2h2v2h-2v3h-3v2H9v-2H7v2H5v-2H2v-3H0V9h2V7H0V5h2V2h3V0zm3 6H6v4h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesCpu
